import { useVeriModel, UseVeriModelOptions } from "../../useVeriModel";
import { OfferingModel } from "../../../models";
import apiOfferingModel from "./apiOfferingModel";

export default function useOfferingModel(
  opts?: UseVeriModelOptions<OfferingModel>,
) {
  return useVeriModel(apiOfferingModel, opts);
}
